<template>
  <div class="content" ref="visitChart">

      <div class="loading">
        <div class="main">
          <span></span>
        </div>
        <div class="text">客官请稍后</div>
      </div>

  </div>
</template>
<script>
// import echarts from "echarts";
let echarts = require('echarts');

import { getLeftChart } from "@/api/admin";

export default {
  data() {
    return {
      xData: [],
      y1Data: [],
      y2Data: [],
    };
  },
  created() {
    this._getLeftChart();
  },
  methods: {
    _getLeftChart() {
      getLeftChart().then((res) => {
        this.xData = res.data.time;
        this.y1Data = res.data.all_order;
        this.y2Data = res.data.success_order;
        this.handleSetVisitChart();

      });
    },

    handleSetVisitChart() {
      this.visitChart = echarts.init(this.$refs.visitChart);
      this.visitChart.setOption({
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#D7DDE4",
            },
          },
          axisTick: {
            alignWithLabel: true,
            lineStyle: {
              color: "#D7DDE4",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#7F8B9C",
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#F5F7F9",
            },
          },
          data: this.xData,
          boundaryGap: false,
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#7F8B9C",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#F5F7F9",
            },
          },
          type: "value",
        },
        legend: {
          data: ["全部订单(条)", "成交订单(条)"],
          x: "right",
        },
        series: [
          {
            data: this.y1Data,
            name: "全部订单(条)",
            type: "line",
            tooltip: true,
            smooth: true,
            symbol: "none",
            areaStyle: {
              normal: {
                opacity: 0.2,
              },
            },
          },
          {
            data: this.y2Data,
            name: "成交订单(条)",
            type: "line",
            tooltip: true,
            smooth: true,
            symbol: "none",
            areaStyle: {
              normal: {
                opacity: 0.2,
              },
            },
          },
        ],
        color: ["#1495EB", "#00CC66", "#F9D249", "#ff9900", "#9860DF"],
        grid: {
          left: 20,
          right: 20,
          bottom: 20,
          top: 40,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
        },
      });

    },
    handleResize() {
      this.visitChart.resize();
    },
  },
  mounted() {},
  beforeDestroy() {
    if (this.visitChart) {
      this.visitChart.dispose();
      this.visitChart = null;
    }
  },
};
</script>
<style scoped lang="less">
.content {
  height: 380px;
  margin-top: 0;
}
.loading {
     position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    .text {
      margin-top: 10px;
      font-size: 14px;
      text-align: center;
    }
   
    .main {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin: 0 auto;
      position: relative;
      border: 5px solid lightgreen;
      -webkit-animation: turn 2s linear infinite;
    }
    .main span {
      display: inline-block;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: lightgreen;
      position: absolute;
      left: 50%;
      margin-top: -15px;
      margin-left: -15px;
      -webkit-animation: changeBgColor 2s linear infinite;
    }
    @-webkit-keyframes changeBgColor {
      0% {
        background: lightgreen;
      }
      100% {
        background: lightblue;
      }
    }
    @-webkit-keyframes turn {
      0% {
        -webkit-transform: rotate(0deg);
        border-color: lightgreen;
      }
      100% {
        -webkit-transform: rotate(360deg);
        border-color: lightblue;
      }
    }
  }
</style>
